// src/pages/Services.jsx
import React, { useEffect } from 'react';
import Navbar from '../common/Navbar';
import Footer from '../common/Footer';

// Now these are pure content components
import HerbalRemedies from '../components/services/HerbalRemedies';
import ShirodharaTreatment from '../components/services/ShirodharaTreatment';
import PanchakarmaTherapy from '../components/services/PanchakarmaTherapy';
import DetoxRejuvenation from '../components/services/DetoxRejuvenation';
import AbhyangaMassage from '../components/services/AbhyangaMassage';
import HolisticHealing from '../components/services/HolisticHealing';

const Services = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-[#F8F3EA]">
      <Navbar />

      <main>
        <HerbalRemedies />
        <ShirodharaTreatment />
        <PanchakarmaTherapy />
        <DetoxRejuvenation />
        <AbhyangaMassage />
        <HolisticHealing />
      </main>

      <Footer />
    </div>
  );
};

export default Services;